<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <b-card class="mb-0">
        <b-img
          center
          fluid
          :src="require('@/assets/images/logo/LOGOREUNIBOX.png')"
        />
        <br>
        <b-card-title class="mb-1">
          Mot de passe oublié
        </b-card-title>
        <b-card-text class="mb-2">
          Saisissez votre email pour recevoir un lien de réinitialisation.
        </b-card-text>
        <b-form @submit.prevent="submit">
          <b-form-group
            label="Email"
            label-for="forgot-email"
          >
            <b-form-input
              id="forgot-email"
              v-model="email"
              type="email"
              required
            />
          </b-form-group>
          <b-button
            type="submit"
            variant="primary"
            block
            :disabled="loading"
          >
            <b-spinner
              v-if="loading"
              small
            />
            <span v-else>Envoyer le lien</span>
          </b-button>
        </b-form>
        <p
          v-if="sent"
          class="text-success mt-2 text-center"
        >
          Si l'email existe, un lien vient d'être envoyé.
        </p>
        <p class="text-center mt-2">
          <b-link :to="{ name: 'admin-dom-login' }">
            Retour à la connexion
          </b-link>
        </p>
      </b-card>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  BCard, BCardTitle, BCardText, BImg, BForm, BFormGroup, BFormInput, BButton, BSpinner, BLink,
} from 'bootstrap-vue'

export default {
  components: {
    BCard, BCardTitle, BCardText, BImg, BForm, BFormGroup, BFormInput, BButton, BSpinner, BLink,
  },
  data() {
    return {
      email: '',
      loading: false,
      sent: false,
    }
  },
  methods: {
    submit() {
      this.loading = true
      this.$http.post('/admindom/forgotpassword', { email: this.email })
        .then(() => {
          this.loading = false
          this.sent = true
        })
        .catch(() => {
          this.loading = false
          this.sent = true
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
